import * as _ from 'lodash';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class VolunteerService {
    constructor(
        private cookieService: CookieService,
        private http: HttpClient
    ) {}

    add(user) {
        const token = this.cookieService.get('accessToken');
        const queryParams = [
            `access_token=${token}`,
            `email=${encodeURIComponent(user.email)}`
        ];
        return this.http.post('/api/addVolunteer', _.join(queryParams, "&"), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
    }

    delete(id) {
        const token = this.cookieService.get('accessToken');
        const queryParams = [
            `access_token=${token}`,
            `ouid=${id}`
        ];
        return this.http.post('/api/deleteVolunteer', _.join(queryParams, "&"), {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        });
    }
    
    resend(id) {
      const token = this.cookieService.get('accessToken');
      const queryParams = [
          `access_token=${token}`,
          `uid=${id}`
      ];
      return this.http.post('/api/addVolunteer', _.join(queryParams, "&"), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      });
    }
}
